<template>
  <section id="sales-content" v-if="isPublished">
    <transition name="fade" mode="out-in" v-if="!loading">
      <div class="container content-page">
        <h1>{{ content.title }}</h1>
        <div class="form-group col-xs-12 col-sm-12 article-body ql-editor" v-html="content.body"></div>
      </div>
    </transition>
    <transition name="fade" mode="out-in" v-else>
      <SkeletonLoader>
        <div class="text-center col-md-12">
          <h1 style="width: 50%;">...</h1>
          <br>
          <p>...</p>
          <p>...</p>
          <p>...</p>
        </div>
      </SkeletonLoader>
    </transition>
  </section>
</template>

<script>
import SkeletonLoader from './SkeletonLoader.vue';

export default {
  name: 'SalesContent',

  components: {
    SkeletonLoader
  },

  data() {
    return {
      loading: false,
      content: {}
    }
  },

  computed: {
    isPublished() {
      if (this.content && this.content.status === 'published') {
        return true;
      }

      return false;
    },

    setArticleId() {
      const isDevelopment = this.$root.build === 'development';

      // these are intentionally hardcoded: 139 = staging and 204 = production.
      if (isDevelopment) {
        return '139';
      } else {
        return '204';
      }
    }
  },

  async created() {
    let articleUrl = `/api/proxify/domains/prismatic/articles/${this.setArticleId}`;
    this.loading = true;

    await axios
      .get(articleUrl)
      .then(({ data: response }) => {
        this.content = response;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      })
  }
}
</script>

<style scoped lang="scss">
#sales-content {
  display: flex;
}
</style>